/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowNarrowLeft = createReactComponent("outline", "arrow-narrow-left", "IconArrowNarrowLeft", [["path", { "d": "M5 12l14 0", "key": "svg-0" }], ["path", { "d": "M5 12l4 4", "key": "svg-1" }], ["path", { "d": "M5 12l4 -4", "key": "svg-2" }]]);

export { IconArrowNarrowLeft as default };
//# sourceMappingURL=IconArrowNarrowLeft.mjs.map
